export const GET_MY_SCHEDULES_BEGIN = 'GET_MY_SCHEDULES_BEGIN'
export const GET_MY_SCHEDULES_SUCCESS = 'GET_MY_SCHEDULES_SUCCESS'
export const GET_MY_SCHEDULES_ERROR = 'GET_MY_SCHEDULES_ERROR'

export const GET_USER_ATTENDANCE_SUMMARY_BEGIN = 'GET_USER_ATTENDANCE_SUMMARY_BEGIN'
export const GET_USER_ATTENDANCE_SUMMARY_SUCCESS = 'GET_USER_ATTENDANCE_SUMMARY_SUCCESS'
export const GET_USER_ATTENDANCE_SUMMARY_ERROR = 'GET_USER_ATTENDANCE_SUMMARY_ERROR'

export const GET_CURRENT_WEEK_TIME_OFFS_BEGIN = 'GET_CURRENT_WEEK_TIME_OFFS_BEGIN'
export const GET_CURRENT_WEEK_OFFS_SUCCESS = 'GET_CURRENT_WEEK_OFFS_SUCCESS'
export const GET_CURRENT_WEEK_OFFS_ERROR = 'GET_CURRENT_WEEK_OFFS_ERROR'

export const GET_NEXT_WEEK_TIME_OFFS_BEGIN = 'GET_NEXT_WEEK_TIME_OFFS_BEGIN'
export const GET_NEXT_WEEK_TIME_OFFS_SUCCESS = 'GET_NEXT_WEEK_TIME_OFFS_SUCCESS'
export const GET_NEXT_WEEK_TIME_OFFS_ERROR = 'GET_NEXT_WEEK_TIME_OFFS_ERROR'

export const DROP_SCHEDULE_BEGIN = 'DROP_SCHEDULE_BEGIN'
export const DROP_SCHEDULE_SUCCESS = 'DROP_SCHEDULE_SUCCESS'
export const DROP_SCHEDULE_ERROR = 'DROP_SCHEDULE_ERROR'

export const AVAILABLE_SHIFTS_GET_REQUEST = ' AVAILABLE_SHIFTS_GET_REQUEST'
export const AVAILABLE_SHIFTS_GET_SUCCESS = 'AVAILABLE_SHIFTS_GET_SUCCESS'
export const AVAILABLE_SHIFTS_GET_ERROR = 'AVAILABLE_SHIFTS_GET_ERROR'

export const AVAILABLE_SHIFTS_UPDATE_REQUEST = 'AVAILABLE_SHIFTS_UPDATE_REQUEST'
export const AVAILABLE_SHIFTS_UPDATE_SUCCESS = 'AVAILABLE_SHIFTS_UPDATE_SUCCESS'
export const AVAILABLE_SHIFTS_UPDATE_ERROR = 'AVAILABLE_SHIFTS_UPDATE_ERROR'

export const APPLY_OPEN_SHIFT_REQUEST_BEGIN = 'APPLY_OPEN_SHIFT_REQUEST_BEGIN'
export const APPLY_OPEN_SHIFT_SUCCESS = 'APPLY_OPEN_SHIFT_SUCCESS'
export const APPLY_OPEN_SHIFT_ERROR = 'APPLY_OPEN_SHIFT_ERROR'

export const CANCEL_OPEN_SHIFT_REQUEST_BEGIN = 'CANCEL_OPEN_SHIFT_REQUEST_BEGIN'
export const CANCEL_OPEN_SHIFT_SUCCESS = 'CANCEL_OPEN_SHIFT_SUCCESS'
export const CANCEL_OPEN_SHIFT_ERROR = 'CANCEL_OPEN_SHIFT_ERROR'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'

export const GET_DASHBOARD_THIS_WEEK_STATS_BEGIN = 'GET_DASHBOARD_THIS_WEEK_STATS_BEGIN'
export const GET_DASHBOARD_THIS_WEEK_STATS_SUCCESS = 'GET_DASHBOARD_THIS_WEEK_STATS_SUCCESS'
export const GET_DASHBOARD_THIS_WEEK_STATS_FAILED = 'GET_DASHBOARD_THIS_WEEK_STATS_FAILED'

export const GET_DASHBOARD_ACTUAL_SALES_BEGIN = 'GET_DASHBOARD_ACTUAL_SALES_BEGIN'
export const GET_DASHBOARD_ACTUAL_SALES_SUCCESS = 'GET_DASHBOARD_ACTUAL_SALES_SUCCESS'
export const GET_DASHBOARD_ACTUAL_SALES_FAILED = 'GET_DASHBOARD_ACTUAL_SALES_FAILED'

export const GET_DASHBOARD_METRICS_STATS_BEGIN = 'GET_DASHBOARD_METRICS_STATS_BEGIN'
export const GET_DASHBOARD_METRICS_STATS_SUCCESS = 'GET_DASHBOARD_METRICS_STATS_SUCCESS'
export const GET_DASHBOARD_METRICS_STATS_FAILED = 'GET_DASHBOARD_METRICS_STATS_FAILED'

export const GET_DASHBOARD_LAST_WEEK_STATS_BEGIN  = 'GET_DASHBOARD_LAST_WEEK_STATS_BEGIN'
export const GET_DASHBOARD_LAST_WEEK_STATS_SUCCESS  = 'GET_DASHBOARD_LAST_WEEK_STATS_SUCCESS'
export const GET_DASHBOARD_LAST_WEEK_STATS_FAILED  = 'GET_DASHBOARD_LAST_WEEK_STATS_FAILED'

export const GET_DASHBOARD_HOT_FLOOR_STATS_BEGIN = 'GET_DASHBOARD_HOT_FLOOR_STATS_BEGIN'
export const GET_DASHBOARD_HOT_FLOOR_STATS_SUCCESS= 'GET_DASHBOARD_HOT_FLOOR_STATS_SUCCESS'
export const GET_DASHBOARD_HOT_FLOOR_STATS_FAILED = 'GET_DASHBOARD_HOT_FLOOR_STATS_FAILED'

export const GET_REQUESTS_BEGIN = 'GET_REQUESTS_BEGIN'
export const GET_REQUESTS_SUCCESS = 'GET_REQUESTS_SUCCESS'
export const GET_REQUESTS_FAILED = 'GET_REQUESTS_FAILED'

export const GET_SHIFT_REQUESTS_BEGIN = 'GET_SHIFT_REQUESTS_BEGIN'
export const GET_SHIFT_REQUESTS_SUCCESS = 'GET_SHIFT_REQUESTS_SUCCESS'
export const GET_SHIFT_REQUESTS_FAILED = 'GET_SHIFT_REQUESTS_FAILED'

export const DELETE_WORK_SCHEDULE_REQUEST_BEGIN =
 "DELETE_WORK_SCHEDULE_REQUEST_BEGIN"
export const DELETE_WORK_SCHEDULE_REQUEST_SUCCESS =
 "DELETE_WORK_SCHEDULE_REQUEST_SUCCESS"
export const DELETE_WORK_SCHEDULE_REQUEST_FAILED =
"DELETE_WORK_SCHEDULE_REQUEST_FAILED"

export const GET_MESSAGES_BEGIN = 'GET_MESSAGES_BEGIN'
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS'
export const GET_MESSAGES_ERROR = 'GET_MESSAGES_ERROR'

export const GET_NOTIFICATIONS_BEGIN = 'GET_NOTIFICATIONS_BEGIN'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR'


export const GET_SWAPPABLE_EMPLOYEES_BEGIN =
'GET_SWAPPABLE_EMPLOYEES_BEGIN'
export const GET_SWAPPABLE_EMPLOYEES_SUCCESS =
'GET_SWAPPABLE_EMPLOYEES_SUCCESS'
export const GET_SWAPPABLE_EMPLOYEES_FAILED=
'GET_SWAPPABLE_EMPLOYEES_FAILED'

export const RESET_EMPLOYEE_SCHEDULES = 'RESET_EMPLOYEE_SCHEDULES'

export const UPDATE_WORK_SCHEDULE_REQUEST_BEGIN =
 "UPDATE_WORK_SCHEDULE_REQUEST_BEGIN"
export const UPDATE_WORK_SCHEDULE_REQUEST_SUCCESS =
 "UPDATE_WORK_SCHEDULE_REQUEST_SUCCESS"
export const UPDATE_WORK_SCHEDULE_REQUEST_FAILED =
"UPDATE_WORK_SCHEDULE_REQUEST_FAILED"

export const REMOVE_WORK_SCHEDULE_REQUEST = 'REMOVE_WORK_SCHEDULE_REQUEST'

export const GET_REQUEST_TYPES_BEGIN = 'GET_REQUEST_TYPES_BEGIN'
export const GET_REQUEST_TYPES_SUCCESS = 'GET_REQUEST_TYPES_SUCCESS'
export const GET_REQUEST_TYPES_FAILED = 'GET_REQUEST_TYPES_FAILED'

export const DELETE_REQUEST_BEGIN = 'DELETE_REQUEST_BEGIN'
export const DELETE_REQUEST_SUCCESS = 'DELETE_REQUEST_SUCCESS'
export const DELETE_REQUEST_FAILED = 'DELETE_REQUEST_FAILED'

export const UPDATE_MESSAGE_READ_BEGIN = "UPDATE_MESSAGE_READ_BEGIN"
export const UPDATE_MESSAGE_READ_SUCCESS = "UPDATE_MESSAGE_READ_SUCCESS"
export const UPDATE_MESSAGE_READ_FAILED = "UPDATE_MESSAGE_READ_FAILED"

export const UPDATE_MESSAGES_BEGIN = 'UPDATE_MESSAGES_BEGIN'
export const UPDATE_MESSAGES_SUCCESS = 'UPDATE_MESSAGES_SUCCESS'
export const UPDATE_MESSAGES_FAILED = 'UPDATE_MESSAGES_FAILED'


export const GET_USER_REQUESTS_BEGIN = 'GET_USER_REQUESTS_BEGIN'
export const GET_USER_REQUESTS_SUCCESS= 'GET_USER_REQUESTS_SUCCESS'
export const GET_USER_REQUESTS_FAILED = 'GET_USER_REQUESTS_FAILED'

// LABOR BUDGET STATS
export const GET_LABOR_BUDGET_STATS_BEGIN = 'GET_LABOR_BUDGET_STATS_BEGIN'
export const GET_LABOR_BUDGET_STATS_SUCCESS = 'GET_LABOR_BUDGET_STATS_SUCCESS'
export const GET_LABOR_BUDGET_STATS_FAILED = 'GET_LABOR_BUDGET_STATS_FAILED'

// STORE INSIGHTS
export const GET_STORE_INSIGHTS_STATS_BEGIN = 'GET_STORE_INSIGHTS_STATS_BEGIN'
export const GET_STORE_INSIGHTS_STATS_SUCCESS = 'GET_STORE_INSIGHTS_STATS_SUCCESS'
export const GET_STORE_INSIGHTS_STATS_FAILED = 'GET_STORE_INSIGHTS_STATS_FAILED'

// Get Today schedules
export const GET_TODAY_SCHEDULES_BEGIN = 'GET_TODAY_SCHEDULES_BEGIN'
export const GET_TODAY_SCHEDULES_SUCCESS = 'GET_TODAY_SCHEDULES_SUCCESS'
export const GET_TODAY_SCHEDULES_ERROR = 'GET_TODAY_SCHEDULES_ERROR'

// Get All Tasks
export const GET_COMPLETED_TASKS_BEGIN = 'GET_COMPLETED_TASKS_BEGIN'
export const GET_COMPLETED_TASKS_SUCCESS = 'GET_COMPLETED_TASKS_SUCCESS'
export const GET_COMPLETED_TASKS_ERROR = 'GET_COMPLETED_TASKS_ERROR'

// Get All Unassigned Tasks
export const GET_UNASSIGNED_TASKS_BEGIN = 'GET_UNASSIGNED_TASKS_BEGIN'
export const GET_UNASSIGNED_TASKS_SUCCESS = 'GET_UNASSIGNED_TASKS_SUCCESS'
export const GET_UNASSIGNED_TASKS_ERROR = 'GET_UNASSIGNED_TASKS_ERROR'
// Get All Uncompleted Tasks
export const GET_UNCOMPLETED_TASKS_BEGIN = 'GET_UNCOMPLETED_TASKS_BEGIN'
export const GET_UNCOMPLETED_TASKS_SUCCESS = 'GET_UNCOMPLETED_TASKS_SUCCESS'
export const GET_UNCOMPLETED_TASKS_ERROR = 'GET_UNCOMPLETED_TASKS_ERROR'
// Get MY Tasks
export const GET_MY_TASKS_BEGIN = 'GET_MY_COMPLETED_TASKS_BEGIN'
export const GET_MY_TASKS_SUCCESS = 'GET_MY_COMPLETED_TASKS_SUCCESS'
export const GET_MY_TASKS_ERROR = 'GET_MY_COMPLETED_TASKS_ERROR'
// Update MY Task
export const UPDATE_MY_TASK_BEGIN = 'UPDATE_MY_TASK_BEGIN'
export const UPDATE_MY_TASK_SUCCESS = 'UPDATE_MY_TASK_SUCCESS'
export const UPDATE_MY_TASK_FAILED = 'UPDATE_MY_TASK_FAILED'

// Get all assigned store tasks
export const GET_ASSIGNED_STORE_TASKS_BEGIN = 'GET_ASSIGNED_STORE_TASKS_BEGIN'
export const GET_ASSIGNED_STORE_TASKS_SUCCESS = 'GET_ASSIGNED_STORE_TASKS_SUCCESS'
export const GET_ASSIGNED_STORE_TASKS_ERROR = 'GET_ASSIGNED_STORE_TASKS_ERROR'

export const GET_WEATHER_DETAILS_BEGIN = 'GET_WEATHER_DETAILS_BEGIN'
export const GET_WEATHER_DETAILS_SUCCESS = 'GET_WEATHER_DETAILS_SUCCESS'
export const GET_WEATHER_DETAILS_ERROR = 'GET_WEATHER_DETAILS_ERROR'

export const GET_EMPLOYEE_SCHEDULE_BEGIN = 'GET_EMPLOYEE_SCHEDULE_BEGIN'
export const GET_EMPLOYEE_SCHEDULE_SUCCESS = 'GET_EMPLOYEE_SCHEDULE_SUCCESS'
export const GET_EMPLOYEE_SCHEDULE_ERROR = 'GET_EMPLOYEE_SCHEDULE_ERROR'

export const GET_EMPLOYEE_WS_REQUEST_BEGIN = 'GET_EMPLOYEE_WS_REQUEST_BEGIN'
export const GET_EMPLOYEE_WS_REQUEST_SUCCESS = 'GET_EMPLOYEE_WS_REQUEST_SUCCESS'
export const GET_EMPLOYEE_WS_REQUEST_ERROR = 'GET_EMPLOYEE_WS_REQUEST_ERROR'
